import { render, staticRenderFns } from "./sidebar.component.vue?vue&type=template&id=0dc05d2a&scoped=true&"
import script from "./sidebar.component.vue?vue&type=script&lang=js&"
export * from "./sidebar.component.vue?vue&type=script&lang=js&"
import style0 from "./sidebar.component.vue?vue&type=style&index=0&id=0dc05d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc05d2a",
  null
  
)

export default component.exports